"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPicker = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var Popover_1 = require("../Popover");
var ContentPopover_1 = require("../Popover/ContentPopover");
var PickerActivator_1 = require("./PickerActivator");
require("./listPicker.css");
var ListPicker = /** @class */ (function (_super) {
    __extends(ListPicker, _super);
    function ListPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false,
        };
        return _this;
    }
    ListPicker.prototype.selectedOption = function (value) {
        var _this = this;
        if (this.props.value === value) {
            return;
        }
        this.setState({
            open: false,
        }, function () { return _this.props.onChange && _this.props.onChange(value); });
    };
    ListPicker.prototype.getSelectedLabel = function () {
        var _this = this;
        var option = this.props.options.filter(function (opt) { return _this.props.value === opt.value; });
        return option.length === 0 ? '-' : option[0].label;
    };
    ListPicker.prototype.renderResetPicker = function () {
        var _this = this;
        if (!this.props.resettable) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('cancel-selection', { active: !this.props.value }), onClick: function () { return _this.setState({ open: false }, function () { return _this.props.onChange && _this.props.onChange(null); }); } }, { children: this.props.resetLabel })));
    };
    ListPicker.prototype.render = function () {
        var _this = this;
        var onClickActivator = function () { return _this.setState({ open: !_this.state.open }); };
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "list-picker" }, { children: (0, jsx_runtime_1.jsxs)(Popover_1.Popover, __assign({ open: this.state.open, onClickOutside: onClickActivator, appendClickListenerToElementRef: this.props.appendClickListenerToElementRef }, { children: [(0, jsx_runtime_1.jsx)(PickerActivator_1.PickerActivator, { label: this.props.label, labelPicked: this.getSelectedLabel(), icon: this.props.icon, onClick: onClickActivator, disabled: this.props.disabled, type: "default", theme: this.props.pickerTheme }), (0, jsx_runtime_1.jsxs)(ContentPopover_1.ContentPopover, __assign({ theme: this.props.contentTheme }, { children: [this.renderResetPicker(), (0, jsx_runtime_1.jsx)("div", __assign({ className: "option" }, { children: this.props.options.map(function (option) {
                                    var customIcon = option.optionIcon ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "option-icon", icon: option.optionIcon })) : null;
                                    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: _this.selectedOption.bind(_this, option.value), className: (0, clsx_1.default)({ active: _this.props.value === option.value }, option.optionIcon ? 'option-icon' : '') }, { children: [customIcon, (0, jsx_runtime_1.jsx)("div", { children: option.label })] }), option.value || '-'));
                                }) }))] }))] })) })));
    };
    ListPicker.defaultProps = {
        icon: 'icon_management_light',
        resettable: false,
        resetLabel: '-',
        disabled: false,
        pickerTheme: 'primary',
        contentTheme: 'default',
    };
    return ListPicker;
}(React.PureComponent));
exports.ListPicker = ListPicker;
//# sourceMappingURL=ListPicker.js.map